var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFa6SolidWeightScale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_271_7874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 8.25C6 6.6587 6.63214 5.13258 7.75736 4.00736C8.88258 2.88214 10.4087 2.25 12 2.25C13.5913 2.25 15.1174 2.88214 16.2426 4.00736C17.3679 5.13258 18 6.6587 18 8.25C18 9.8413 17.3679 11.3674 16.2426 12.4926C15.1174 13.6179 13.5913 14.25 12 14.25C10.4087 14.25 8.88258 13.6179 7.75736 12.4926C6.63214 11.3674 6 9.8413 6 8.25ZM18.3656 3C16.8516 1.16719 14.5641 0 12 0C9.43594 0 7.14844 1.16719 5.63437 3H3C1.34531 3 0 4.34531 0 6V21C0 22.6547 1.34531 24 3 24H21C22.6547 24 24 22.6547 24 21V6C24 4.34531 22.6547 3 21 3H18.3656ZM13.875 10.5C13.875 10.0031 13.6828 9.55313 13.3641 9.21563L14.9391 5.54531C15.1031 5.16563 14.925 4.725 14.5453 4.56094C14.1656 4.39688 13.725 4.575 13.5609 4.95469L11.9859 8.625C10.9547 8.62969 10.125 9.46875 10.125 10.5C10.125 11.5359 10.9641 12.375 12 12.375C13.0359 12.375 13.875 11.5359 13.875 10.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_271_7874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFa6SolidWeightScale);
export default __webpack_public_path__ + "static/media/fa6-solid_weight-scale.7414a465665766f090953f60fb4972ff.svg";
export { ForwardRef as ReactComponent };